@if (svg) {
  <span [innerHTML]="svg"></span>
}
